import React, {useCallback, useEffect, useState} from 'react';
import {useForm, Controller} from "react-hook-form";

import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import CardHeader from '@mui/material/CardHeader';
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import TextField from '@mui/material/TextField';
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
//import {useDocument, useDocumentOnce} from "react-firebase-hooks/firestore";
//import {doc, getFirestore} from "firebase/firestore";

import Alert from "@mui/material/Alert";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";

import Loading from "../common/Loading";
import {useAuth} from "../../context/AuthProvider";
import EmployeeService from "../../services/employee.service";

const formState = {
    email: "",
    empAddress: "",
    empId: "",
    empName: "",
    empPhone: "",
    userId: "",
}

const schema = yup.object({
    email: yup.string().email("Invalid email address!"),
    empAddress: yup.string().nullable(),
    empId: yup.string(),
    empName: yup.string(),
    empPhone: yup.string().nullable(),
    userId: yup.string(),
}).required();

const AccountForm = () => {
    const {user} = useAuth();
    const {handleSubmit, control, formState: {errors}, reset} = useForm({
        resolver: yupResolver(schema),
        defaultValues: formState
    });
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(formState);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);

    const fetchEmployee = useCallback((empId) => {
        EmployeeService.getDocById(empId).then((docSnap) => {
            if (docSnap.exists()) {
                const docData = {id: docSnap.id, ...docSnap.data()}
                setData(docData);
                reset(docData);
            } else {
                reset(formState)
                setError({message: "Data fetching error"})
            }
        });
    }, [reset]);

    useEffect(() => {
        if (user) {
            fetchEmployee(user.uid);
        }
    }, [user, fetchEmployee]);

    const handleFormSubmit = async (data) => {
        setLoading(true);
        const docId = user.uid;
        if (docId) {
            // making sure email gets copied from user.
            data.email = user.email;
            EmployeeService.createOrUpdate(docId, data).then((response) => {
                setMessage("Success! Details are saved!");
                setLoading(false);
            }).catch((error) => {
                setError({message: "Failed! Details aren't saved!"})
            });
        }
    }
    if (loading) {
        return <Loading/>
    }
    return (
        <Card>
            <Box component="form" noValidate sx={{mt: 1}} onSubmit={handleSubmit(handleFormSubmit)}>
                {error && <Alert severity="error">{error.message}</Alert>}
                {message && <Alert severity="success">{message}</Alert>}
                <CardHeader subheader="The information can be edited" title="Employee Details"/>
                <Divider/>
                <CardContent>
                    <Grid
                        container
                        spacing={3}
                    >
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                value={data.email}
                                label="Employee email"
                                disabled={true}
                                variant="outlined"
                            />

                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <FormControl fullWidth={true}>
                                <Controller
                                    name="empName"
                                    control={control}
                                    render={({field}) =>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label="Employee name"
                                            variant="outlined"
                                            error={!!errors.empName}
                                            helperText={errors.empName && errors.empName?.message}
                                        />}
                                />
                            </FormControl>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                disabled={true}
                                value={data.empId}
                                label="Employee Id"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <FormControl fullWidth={true}>
                                <Controller
                                    name="empAddress"
                                    control={control}
                                    render={({field}) =>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label="Address"
                                            variant="outlined"
                                            error={!!errors.empAddress}
                                            helperText={errors.empAddress && errors.empAddress?.message}
                                        />
                                    }
                                />
                            </FormControl>

                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <FormControl fullWidth={true}>
                                <Controller
                                    name="empPhone"
                                    control={control}
                                    render={({field}) =>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label="Phone number"
                                            variant="outlined"
                                            error={!!errors.empPhone}
                                            helperText={errors.empPhone && errors.empPhone?.message}
                                        />
                                    }
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </CardContent>
                <Divider/>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        p: 2
                    }}
                >
                    <Button
                        color="primary"
                        variant="contained"
                        type="submit"
                    >
                        Save details
                    </Button>
                </Box>
            </Box>
        </Card>
    );
};

export default AccountForm;